import api from "../Api";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") ||
    sessionStorage.getItem("token") ||
    null;

  return token ? { Authorization: `Bearer ${token}` } : {};
};

// ✅ Get My Cart
export const getMyCart = async (params = {}) => {
  const response = await api.get("/user/my-cart", {
    headers: {
      Accept: "application/json",
      ...getAuthHeaders(),
    },
    params: {
      api_password: "EcommercApp@2026_$",
      ...params,
    },
  });

  return response.data;
};
// ✅ Add item to cart
export const addToCart = async ({ product_id, size_id = null, color_id = null, quantity = 1 }) => {
  if (!product_id) throw new Error("product_id is required");

  const payload = {
    product_id,
    size_id: size_id ?? null,
    color_id: color_id ?? null,
    quantity: Number(quantity || 1),
  };

  const response = await api.post("/user/cart/add", payload, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...getAuthHeaders(),
    },
    params: {
      api_password: "EcommercApp@2026_$",
    },
  });

  return response.data;
};
// ✅ Update cart item quantity (الدالة اللي في الصورة)
export const updateCartItem = async ({ item_id, quantity }) => {
  if (!item_id) throw new Error("item_id is required");

  const payload = {
    item_id: Number(item_id),
    quantity: Number(quantity),
  };

  const response = await api.post("/user/cart/update", payload, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...getAuthHeaders(),
    },
    params: {
      api_password: "EcommercApp@2026_$",
    },
  });

  return response.data;
};
// ✅ Delete item from cart
export const deleteCartItem = async ({ item_id }) => {
  if (!item_id) throw new Error("item_id is required");

  const payload = { item_id: Number(item_id) };

  const res = await api.post(
    "https://didamax.net/api/user/cart/delete",
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...getAuthHeaders(),
      },
      params: {
        api_password: "EcommercApp@2026_$",
      },
    }
  );

  return res.data;
};
// ✅ Easykash payment
export const easykashPayment = async ({ order_id }) => {
  if (!order_id) throw new Error("order_id is required");

  const response = await api.post(
    "/easykash/card",
    { order_id: Number(order_id) },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...getAuthHeaders(),
      },
      params: {
        api_password: "EcommercApp@2026_$",
      },
    }
  );

  return response.data;
};
// ✅ Clear cart (remove all items)
export const clearCart = async () => {
  const response = await api.get("/user/cart/clear", {
    headers: {
      Accept: "application/json",
      ...getAuthHeaders(),
    },
    params: {
      api_password: "EcommercApp@2026_$",
    },
  });

  return response.data;
};
